// src/reducers/authReducer.js

import { toast } from "react-toastify"
import {
    AUTH_CLEAR_ERROR,
        AUTH_FAIL,
        AUTH_RESET,
        AUTH_SUCCESS,
        FETCH_ERROR,
        LOGOUT,
        SET_AUTH,
        SET_AUTH_LOADING,
        SET_USER,
        UPDATE_FAIL
    } from "../actions/authTypes"

const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true'
const user = (localStorage.getItem('user') !== "undefined" && localStorage.getItem('user'))  ? JSON.parse(localStorage.getItem('user')) : null

const initialState = {
    user: user,
    isLoggedIn: isLoggedIn,
    loading: false,
    authSuccess: false,
    authError: false,
    fetchError: false
}

export const authReducer = (state = initialState, action) => {
    switch(action.type){
        case SET_AUTH:
            localStorage.setItem('user',JSON.stringify(action.payload))
            localStorage.setItem('isLoggedIn', 'true')
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload
            }
        case SET_USER:
            localStorage.setItem('user',JSON.stringify(action.payload))
            return {
                ...state,
                user: action.payload
            }
        case LOGOUT:
            localStorage.removeItem('isLoggedIn')
            localStorage.removeItem('user')
            return {
                ...state,
                user: null,
                isLoggedIn: false
            }
        case AUTH_SUCCESS:
            return {
                ...state,
                authSuccess: action.payload
            }
        case AUTH_FAIL:
            return  {
                ...state,
                authError: action.payload
            }
        case UPDATE_FAIL:
            const message = `Unable to ${action.payload}. Try again later!`
            toast.error(
                <span style = {{ fontSize: "13.5px", fontFamily: 'Poppins, sans-serif'}}>
                   {message}
                </span>,
                {
                    position: "bottom-left"
                }
            )
            return state
        case FETCH_ERROR:
            return {
                ...state,
                fetchError: action.payload
            }
        case SET_AUTH_LOADING:
            if (action.payload){
                return {
                    ...state,
                    authError: false,
                    authSuccess: false,
                    loading: action.payload
                }
            }
            else{
                return {
                    ...state,
                    loading: action.payload
                }
            }
        case AUTH_CLEAR_ERROR:
            return {
                ...state,
                authError: false
            }
        case AUTH_RESET:
            return {
                ...state,
                loading: false,
                authError: false,
                authSuccess: false,
                fetchError: false
            }
        default:
            return state
    }
}